import { render, staticRenderFns } from "./provideList.vue?vue&type=template&id=b8e69938&scoped=true&"
import script from "./provideList.vue?vue&type=script&lang=js&"
export * from "./provideList.vue?vue&type=script&lang=js&"
import style0 from "./provideList.vue?vue&type=style&index=0&id=b8e69938&scoped=true&lang=css&"
import style1 from "./provideList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e69938",
  null
  
)

export default component.exports